import { parseNumberAndFormat } from '@/domain/mitarbeiter/features/feiertagskonto/shared';
import { Field, FieldLabel, InlineAlert, Input } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

type AnzahlFieldProps = {
  error: string;
  anzahl: string | number;
  validateAnzahl: (value: string | number) => void;
  setAnzahl: (value: string | number) => void;
  setError: (value: string) => void;
};

export function AnzahlField({
  error,
  anzahl,
  validateAnzahl,
  setAnzahl,
  setError,
}: AnzahlFieldProps) {
  const { t } = useTranslation();

  return (
    <Field data-invalid={!!error}>
      <FieldLabel invalid={!!error} requiredField>
        {t('domain.mitarbeiter.feiertagskonto.uebertragAusVorjahr.anzahl')}
      </FieldLabel>
      <Input
        required
        showSuffix
        suffix={t('domain.mitarbeiter.feiertagskonto.tage')}
        id="UebertragNumber"
        value={anzahl}
        step=".5"
        type="number"
        min={-99.5}
        max={99.5}
        aria-invalid={!!error}
        onChange={(e) => {
          validateAnzahl(e.target.value);
          setAnzahl(e.target.value);
          setError(undefined);
        }}
        onBlur={(e) => {
          setAnzahl(parseNumberAndFormat(e.target.value));
          validateAnzahl(e.target.value);
          setError(undefined);
        }}
      />
      {error && <InlineAlert description={error} />}
    </Field>
  );
}
